import { useNavigate } from "react-router-dom";

import "./topbar.css";
import { Chat, Notifications, Person, Search } from "@mui/icons-material";

export default function Topbar() {
  const navigate = useNavigate();

  function goToHome() {
    navigate("/");
  }
  function goToProfile() {
    navigate("/profile");
  }

  return (
    <div className="topbarContainer">
      <div className="topbarLeft">
        <span className="logo" onClick={goToHome}>Socialbook</span>
      </div>
      <div className="topbarCenter">
        <div className="searchbar">
          <Search className="searchIcon" />
          <input placeholder="Search for friend, post or video" className="searchInput" />
        </div>
      </div>
      <div className="topbarRight">
        <div className="topbarLinks">
          <span className="topbarLink" onClick={goToHome}>Homepage</span>
        </div>
        <div className="topbarIcons">
          <div className="topbarIconItem">
            <Person />
            <span className="topbarIconBadge">1</span>
          </div>
          <div className="topbarIconItem">
            <Chat />
            <span className="topbarIconBadge">2</span>
          </div>
          <div className="topbarIconItem">
            <Notifications />
            <span className="topbarIconBadge">1</span>
          </div>
        </div>
        <img src="/assets/person/human_12.jpg" alt="" className="topbarImg" onClick={goToProfile} />
      </div>
    </div>
  )
}
